"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarCarousel = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var GenericThumbnail_1 = require("./GenericThumbnail");
function SidebarCarousel(_a) {
    var items = _a.items, onClick = _a.onClick, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd;
    return (react_1.default.createElement(kaleidoscope_1.Carousel, { buttonsAlwaysShow: false, itemsPerSlide: 2 }, items.map(function (asset, index) { return (react_1.default.createElement(kaleidoscope_1.CarouselItem, { key: index },
        react_1.default.createElement(GenericThumbnail_1.GenericThumbnail, { asset: asset, onClick: function () { return onClick(asset); }, onDragStart: function () { return onDragStart(asset); }, onDragEnd: function () { return onDragEnd(asset); } }))); })));
}
exports.SidebarCarousel = SidebarCarousel;
